import { request } from "../../../backend";

/**
 * Cancels an agreement with a given key.
 * @param agreementKey Key of agreement to cancel
 */
export async function cancelAgreement(agreementKey: string) {
  await request(`/agreements/${agreementKey}/cancel`, 'post');
}

export async function deleteAgreement(agreementKey: string) {
  await request(`/agreements/${agreementKey}`, 'delete');
}